import React from 'react';
import iWillLogoWhite from '../../../assets/iWillLogoWhite.png';
import { Link, useLocation } from 'react-router-dom';
import { Icon, Icons } from 'components/Icon';
import { adminNavs } from 'constants/nav';
import { IUserNav } from 'types/INav.type';
import { determinePathName } from 'utils';
import { useSideBarFilter } from 'common/hooks/useTabFilter';

type Props = {
  show: boolean;
  setShow: () => void;
};
export default function AdminSideBar({ show, setShow }: Readonly<Props>) {
  const { pathname } = useLocation();

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-40 w-[15rem] ${
        !show
          ? '-translate-x-full sm:translate-x-0 md:relative md:-translate-x-0 '
          : ''
      } space-y-6 bg-[#121638] transition duration-200 ease-in-out `}
      aria-label="Sidebar"
    >
      <div className="h-screen overflow-y-auto bg-[#121638] pb-10">
        <div className="sticky top-0 z-50 flex bg-[#121638] pl-[34px] pt-[30px]">
          <div className="flex w-full items-center justify-between">
            <Link
              to="/admin"
              className="m-4 ml-5 flex items-center justify-center self-center md:mr-24"
              onClick={setShow}
            >
              <img src={iWillLogoWhite} className="h-12 md:ml-8" alt="Logo" />
            </Link>
            <button
              className="mr-2 flex justify-end md:hidden"
              onClick={setShow}
            >
              <Icon name={Icons.Close} fill="#FFFFFF" />
            </button>
          </div>
        </div>
        <div className="z-50 h-[calc(100%-80px)] overflow-y-auto bg-[#121638] py-2 scrollbar-hide">
          <ul className="mt-10 space-y-3">
            {useSideBarFilter(adminNavs).map((item: IUserNav) => (
              <li
                key={item.path}
                className={`px-4 text-sm ${
                  determinePathName(pathname) === item.main
                    ? 'border-l-4 border-[#FFFFFF] bg-gradient-to-r from-[#FF6600] font-semibold'
                    : 'font-normal hover:bg-gray-700'
                } `}
              >
                <Link
                  to={item.path}
                  className="group flex items-center rounded-lg p-2 text-white"
                  onClick={() => setShow()}
                >
                  <Icon name={item.icon} />
                  <span className="ml-3 ">{item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  );
}
